import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  id: 1,
  name: 'Valentina R.',
  treatment: 'Tratamiento Facial Anti-Age',
  quote: 'Desde que empecé a atenderme en AURA, mi piel cambió por completo. El nivel de profesionalismo y el ambiente relajante hacen que cada sesión sea un mimo al alma.'
}, {
  id: 2,
  name: 'Sofía M.',
  treatment: 'Depilación Láser',
  quote: 'Increíble la tecnología que usan. No sentí nada de dolor y los resultados se vieron desde la primera sesión. La atención es impecable, te hacen sentir única.'
}, {
  id: 3,
  name: 'Camila T.',
  treatment: 'Modelado Corporal',
  quote: 'Llegué con muchas inseguridades y me acompañaron en todo el proceso con mucha empatía. Hoy me siento mucho más segura de mí misma. ¡Gracias totales!'
}];
export function Testimonials() {
  return <section id="testimonios" className="py-24 bg-softwhite relative" data-id="element-206">
      <div className="container mx-auto px-6 md:px-12" data-id="element-207">
        <div className="text-center mb-16" data-id="element-208">
          <motion.span initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} className="text-rosegold text-sm font-sans uppercase tracking-[0.2em] mb-4 block" data-id="element-209">
            Experiencias Reales
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-serif text-deepblack" data-id="element-210">
            Lo que dicen nuestras{' '}
            <span className="italic font-light" data-id="element-211">clientas</span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-212">
          {testimonials.map((testimonial, index) => <motion.div key={testimonial.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-white p-10 rounded-2xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.05)] relative border border-nude" data-id="element-213">
              <div className="text-rosegold/20 mb-6" data-id="element-214">
                <svg width="45" height="36" viewBox="0 0 45 36" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-215">
                  <path d="M13.5 0C6.04416 0 0 6.04416 0 13.5V36H18V13.5H9C9 8.52944 13.0294 4.5 18 4.5V0H13.5ZM40.5 0C33.0442 0 27 6.04416 27 13.5V36H45V13.5H36C36 8.52944 40.0294 4.5 45 4.5V0H40.5Z" data-id="element-216" />
                </svg>
              </div>
              <p className="text-deepblack/80 font-sans font-light leading-relaxed mb-8 italic text-lg" data-id="element-217">
                "{testimonial.quote}"
              </p>
              <div data-id="element-218">
                <h4 className="font-serif font-semibold text-deepblack text-lg" data-id="element-219">
                  {testimonial.name}
                </h4>
                <p className="text-sm font-sans text-mauve uppercase tracking-wider mt-1" data-id="element-220">
                  {testimonial.treatment}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}